import 'chart.js/auto';

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

export type MonthPoint = { year: number; month: number };

export const monthKey = (year: number, month: number) => `${year}-${month}`;

const compareMonthKeys = (a: string, b: string) => {
  const [yearA, monthA] = a.split('-').map(Number);
  const [yearB, monthB] = b.split('-').map(Number);
  return yearA === yearB ? monthA - monthB : yearA - yearB;
};

export const formatMonth = (year: number, month: number, withYear = true) => {
  const date = new Date(Date.UTC(year, month - 1, 1));
  return date.toLocaleDateString('en-US', withYear ? { month: 'short', year: '2-digit' } : { month: 'short' });
};

export const indexByMonth = <T extends MonthPoint>(entries?: readonly T[]) =>
  new Map(entries?.map((entry) => [monthKey(entry.year, entry.month), entry] as const));

export const mergeMonthKeys = (...series: (readonly MonthPoint[] | undefined)[]) =>
  Array.from(new Set(series.flatMap((entries) => entries?.map((entry) => monthKey(entry.year, entry.month)) ?? []))).sort(
    compareMonthKeys
  );

export const parseMonthKey = (key: string) => {
  const [year, month] = key.split('-').map(Number);
  return { year, month };
};
